import { SearchBar as SearchBarBase } from "@omni/components/components/Search/SearchBar/searchBar";
import { SearchBarProps } from "@omni/types/components/props/searchBar.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { SearchBarComponent } from "@/components/Search/SearchBar/searchBar.component";

export const SearchBar = ({
    initialProducts
}: SearchBarProps<BaseStore.Hubo>) => {
    return (
        <SearchBarBase initialProducts={initialProducts}>
            <SearchBarComponent />
        </SearchBarBase>
    );
};
